import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60e9859c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e9859c')) {
      api.createRecord('60e9859c', component.options)
    } else {
      api.reload('60e9859c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=60e9859c", function () {
      api.rerender('60e9859c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Plants/Producer/Stock/index.vue"
export default component.exports